exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n    overflow: hidden;\n    padding: 3em 0;\n    border-top: 1px solid #eaeaea;\n}\n.logo {\n    background-image: url(/assets/images/logo-slab-bg.jpg);\n    width: 150px;\n    max-width: 100%;\n    background-size: cover;\n}\n.copyright {\n    color: #333;\n    margin-top: 30px;\n    font-size: .8em;\n    text-align: center;\n}\nbutton.scroll-button {\n    background: none;\n    border: none;\n    color: #606060;\n    cursor: pointer;\n}\nbutton.scroll-button:focus {\n    outline: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_0264da94/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main